export default "__VITE_ASSET__BCvJzCmt__"